import { Action } from 'redux';

import {
  AxiosAction,
  isSuccessActionOf
} from '../middleware/axios';
import { isAction } from '../utils';

import {
  UserDefinedRoleCreateDto,
  UserDefinedRoleResponseDto,
  UserDefinedRoleUpdateDto
} from './state';

// Action Types

const GET_USER_DEFINED_ROLES = 'USER_DEFINED_ROLES.GET_ALL';
const GET_USER_DEFINED_ROLE = 'USER_DEFINED_ROLES.GET';
const CREATE_USER_DEFINED_ROLE = 'USER_DEFINED_ROLES.CREATE';
const UPDATE_USER_DEFINED_ROLE = 'USER_DEFINED_ROLES.UPDATE';
const CLEAR_RECENTLY_MODIFIED = 'USER_DEFINED_ROLES.CLEAR_RECENTLY_MODIFIED';

// Action Interfaces

export interface GetUserDefinedRoles extends AxiosAction<UserDefinedRoleResponseDto[]> {
  type: typeof GET_USER_DEFINED_ROLES;
}
export interface GetUserDefinedRole extends AxiosAction<UserDefinedRoleResponseDto> {
  type: typeof GET_USER_DEFINED_ROLE;
}
export interface CreateUserDefinedRole extends AxiosAction<UserDefinedRoleResponseDto> {
  type: typeof CREATE_USER_DEFINED_ROLE;
}
export interface UpdateUserDefinedRole extends AxiosAction<UserDefinedRoleResponseDto> {
  type: typeof UPDATE_USER_DEFINED_ROLE;
}
export interface ClearRecentlyModified extends Action {
  type: typeof CLEAR_RECENTLY_MODIFIED;
}

// Actions Creators

/** Gets all user-defined roles available to the current user. */
export function getUserDefinedRoles(): GetUserDefinedRoles {
  return {
    payload: {
      client: 'coreService',
      request: {
        url: '/users/roles/user-defined'
      }
    },
    type: GET_USER_DEFINED_ROLES
  };
}
export const isGetUserDefinedRoles = isAction<GetUserDefinedRoles>(GET_USER_DEFINED_ROLES);
export const isGetUserDefinedRolesSuccess = isSuccessActionOf<GetUserDefinedRoles>(GET_USER_DEFINED_ROLES);

/** Gets the user-defined role with the given code. */
export function getUserDefinedRole(code: string): GetUserDefinedRole {
  return {
    payload: {
      client: 'coreService',
      request: {
        url: `/users/roles/user-defined/${code}`
      }
    },
    type: GET_USER_DEFINED_ROLE
  };
}
export const isGetUserDefinedRole = isAction<GetUserDefinedRole>(GET_USER_DEFINED_ROLE);
export const isGetUserDefinedRoleSuccess = isSuccessActionOf<GetUserDefinedRole>(GET_USER_DEFINED_ROLE);

/** Creates a user-defined role with the given contents. */
export function createUserDefinedRole(data: UserDefinedRoleCreateDto): CreateUserDefinedRole {
  return {
    payload: {
      client: 'coreService',
      request: {
        data,
        method: 'POST',
        url: '/users/roles/user-defined'
      }
    },
    type: CREATE_USER_DEFINED_ROLE
  };
}
export const isCreateUserDefinedRole = isAction<CreateUserDefinedRole>(CREATE_USER_DEFINED_ROLE);
export const isCreateUserDefinedRoleSuccess = isSuccessActionOf<CreateUserDefinedRole>(CREATE_USER_DEFINED_ROLE);

/** Updates the user-defined role with the given code to have the given contents. */
export function updateUserDefinedRole(
  code: string,
  data: UserDefinedRoleUpdateDto
): UpdateUserDefinedRole {
  return {
    payload: {
      client: 'coreService',
      request: {
        data,
        method: 'PATCH',
        url: `/users/roles/user-defined/${code}`
      }
    },
    type: UPDATE_USER_DEFINED_ROLE
  };
}
export const isUpdateUserDefinedRole = isAction<UpdateUserDefinedRole>(UPDATE_USER_DEFINED_ROLE);
export const isUpdateUserDefinedRoleSuccess = isSuccessActionOf<UpdateUserDefinedRole>(UPDATE_USER_DEFINED_ROLE);

/** Clears the history of recently modified user-defined roles. */
export function clearRecentlyModified() {
  return {
    type: CLEAR_RECENTLY_MODIFIED
  };
}
export const isClearRecentlyModified = isAction<ClearRecentlyModified>(CLEAR_RECENTLY_MODIFIED);
